<template>
  <!-- Widgets wrapper -->
  <b-col :md="wrapperCols" id="lm-widget">
    <!-- Widgets en Card -->
    <template v-if="!isGroupMode">
      <b-card
        no-body
        :style="setBgColor(customization.color)"
        :class="customClasses"
      >
        <b-card-body :class="{ 'p-0': component === 'LmCounter' }">
          <Component
            :key="key"
            v-if="component"
            :is="widgetsToRender.component"
            :widget="properties"
            :customization="customization"
          />
        </b-card-body>
        <b-card-footer v-if="isOnCustomizationMode">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex" style="column-gap: 1em">
              <LmSelect
                class="m-0 d-flex align-items-center"
                v-model="customization.size"
                :options="sizeOptions"
                @input="onSizeChange"
              />
              <LmColorPicker
                :key="key"
                v-if="showColorPicker"
                class="mt-1"
                :swatches="swatches"
                v-model="customization.color"
                @input="onColorChange"
              />
              <LmTextInput
                v-if="showTitleInput"
                class="mb-0"
                v-model="customization.text"
                placeholder="Escribe un título"
                @input="onTitleChange"
              />
            </div>
            <font-awesome-icon @click="onWidgetRemoveConfirmation" style="width:18px;height:18px" icon="times" class="clickable"></font-awesome-icon>
          </div>
        </b-card-footer>
      </b-card>
    </template>

    <!-- Groupos de widgets en Tabs -->
    <div class="border shadow bg-light" v-if="isGroupMode" style="margin-bottom: 30px">
      <h4 class="px-4 py-2">{{ widget.label }}</h4>
      <b-tabs nav-class="px-2">
        <b-tab v-for="(el, index) in widgetsToRender" :key="index" lazy>
          <template #title>
            <div :style="setBgColor(el.customization.color)" class="py-2 px-3">
              {{ el.customization.title || el.name }}
              <span v-if="isOnCustomizationMode" class="ml-2">
                <b-dropdown size="lg"  variant="link" toggle-class="text-decoration-none" no-caret>
                  <template #button-content>
                    <i class="mdi mdi-tune-variant"></i>
                  </template>
                  <LmTextInput
                    class="mb-0 px-2"
                    label="Escribe un título"
                    v-model="el.customization.title"
                    placeholder="Escribe un título"
                  />
                </b-dropdown>
              </span>
            </div>
          </template>
          <div :key="key" :class="[ el.component !== 'LmCounter' ? 'p-4' : '' ]" :style="setBgColor(el.customization.color)">
            <Component
              v-if="el.component"
              :is="el.component"
              :widget="el.properties"
              :customization="el.customization"
              hideTitle
            />
          </div>
        </b-tab>
      </b-tabs>
      <b-card-footer v-if="isOnCustomizationMode">
        <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex" style="column-gap: 1em">
              <LmTextInput
                class="mb-0"
                v-model="widget.label"
                placeholder="Escribe un título"
              />
            </div>
            <font-awesome-icon @click="onWidgetRemoveConfirmation" style="width:18px;height:18px" icon="times" class="clickable"></font-awesome-icon>
          </div>
      </b-card-footer>
    </div>
    <LmConfirmationModal ref="lmConfirmationModal" title="Aviso" @ok="onWidgetRemove" />
  </b-col>
</template>

<script>
// Components
import LmSelect from '@/components/form/elements/LmSelect'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmColorPicker from '@/components/form/elements/LmColorPicker'
import LmConfirmationModal from '@/components/modals/LmConfirmationModal.vue'

// Widgets components
import LmList from '@/components/widgets/elements/LmList'
import LmTitle from '@/components/widgets/elements/LmTitle'
import LmEChartPie from '@/components/widgets/elements/LmEChartPie'
import LmEChartBars from '@/components/widgets/elements/LmEChartBars'
import LmDataTable from '@/components/widgets/elements/LmDataTable'
import LmCounter from '@/components/widgets/elements/LmCounter'

export default {
  props: {
    widget: {
      type: Object,
      required: true
    },
    isOnCustomizationMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    LmSelect,
    LmTextInput,
    LmColorPicker,
    LmConfirmationModal,
    LmList,
    LmTitle,
    LmEChartPie,
    LmEChartBars,
    LmDataTable,
    LmCounter
  },
  data () {
    return {
      key: 0,
      wrapperCols: 12,
      swatches: [
        ['#F6648B', '#F493A7', '#F891A6', '#FFCCD5'],
        ['#a27bff', '#b99cff', '#d0bdff', '#e8deff'],
        ['#74ebe3', '#96f0ea', '#b9f5f1', '#dcfaf8'],
        ['#ffb748', '#ffc976', '#ffdba3', '#ffedd1'],
        ['']
      ],
      sizes: {
        3: '25%',
        6: '50%',
        9: '75%',
        12: '100%'
      }
    }
  },
  computed: {
    isGroupMode () {
      return this.widget.type === 'group'
    },
    widgetsToRender () {
      return this.widget.render
    },
    component () {
      if (!this.isGroupMode) {
        return this.widgetsToRender?.component || {}
      }
      return null
    },
    properties () {
      if (!this.isGroupMode) {
        return this.widgetsToRender?.properties || {}
      }
      return {}
    },
    customization () {
      if (!this.isGroupMode) {
        return this.widgetsToRender?.customization || {}
      }
      return {}
    },
    // Condicionales para componentes segun el widget
    showColorPicker () {
      if (this.component === 'LmTitle') {
        return false
      }
      return true
    },
    showTitleInput () {
      if (this.component === 'LmTitle') {
        return true
      }
      return false
    },
    // Clases segun el widget
    customClasses () {
      if (this.component === 'LmTitle') {
        return 'bg-light'
      }
      return 'shadow'
    },
    // Opciones de tamaños
    sizeOptions () {
      if (this.properties?.sizes) {
        const options = this.properties.sizes.map(s => {
          return {
            value: s,
            text: this.sizes[s]
          }
        })
        return {
          content: options
        }
      }
      // Si no existe la propiedad "sizes", no muestro opciones
      return {
        content: []
      }
    }
  },
  methods: {
    setBgColor (color) {
      return `background-color: ${color || 'white'}`
    },
    setColsSize () {
      if ('size' in this.customization) {
        return this.customization.size
      }
      return 12
    },
    async onWidgetRemoveConfirmation () {
      try {
        await this.$refs.lmConfirmationModal.lmShow()
      } catch (error) {
        console.log(error)
      }
    },
    onWidgetRemove () {
      this.$emit('onWidgetRemove')
    },
    onSizeChange (event) {
      this.wrapperCols = event
      this.$emit('onWidgetCustomizationChange', { size: event })
      this.key++
    },
    onColorChange (event) {
      this.$emit('onWidgetCustomizationChange', { color: event })
      this.key++
    },
    onTitleChange (event) {
      this.$emit('onWidgetCustomizationChange', { title: event })
      this.key++
    }
  },
  created () {
    if (this.widget.type === 'single') {
      this.wrapperCols = this.widget.render?.customization?.size || 12
    } else {
      this.wrapperCols = 12
    }
  }
}
</script>

<style lang="sass">
  #lm-widget
    .nav-item .nav-link
      padding: 0 !important
    .dropdown-toggle
      padding: 0
      i.mdi
        color: #495057
      &:focus
        box-shadow: none
</style>
